import type { FC } from "react";
import type { BreadcrumbFrom } from "./Breadcrumb";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Breadcrumb from "./Breadcrumb";
import BackButton from "../atoms/buttons/BackButton";
import { theme } from "../../theme";
import Subtitle from "../atoms/typography/Subtitle";

interface Props {
  from?: BreadcrumbFrom;
  onClickBack?: () => void;
  titleKey: string;
  currentTitleKey: string;
}

const SecondaryPageTitleSection: FC<Props> = ({
  from,
  onClickBack,
  titleKey,
  currentTitleKey,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const onGoBack = () => (onClickBack ? onClickBack() : navigate(-1));

  return (
    <div>
      {from && <Breadcrumb from={from} currentTitle={t(currentTitleKey)} />}
      <div
        style={{ display: "flex", alignItems: "center", gap: 16, marginTop: 8 }}
      >
        <BackButton onClick={onGoBack} color={theme.colors.primary20} />
        <Subtitle color={theme.colors.primary}>{t(titleKey)}</Subtitle>
      </div>
    </div>
  );
};

export default SecondaryPageTitleSection;
